import { useContext, createContext } from "react";

export const AskomaContext = createContext(null);

export function useAskomaContext() {
  const context = useContext(AskomaContext);

  if (!context) {
    throw new Error(
      "useAskomaContext must be used inside AskomaContext.Provider",
    );
  }

  return context;
}
